import useMcdApiQuery from './useMcdApiQuery'

export interface IRequest {
  INVOICE_NO?: string // 送り状番号
}

export interface DistDateChangedAcceptValue {
  INVOICE_NO: string // 送り状番号
  INVOICE_NO_EXISTS_FLG: boolean // 送り状番号存在フラグ（FALSEなら配送伝票に存在する送り状番号、TRUEなら配送伝票に存在しない送り状番号）
  TIMEZONE_PROV_FLG: (0 | 1) // 置配可能フラグ（1なら受け取り方法を選択可能）
  PKG_DROPPABLE_FLG: (0 | 1) // 時間帯提供フラグ（1なら希望時間帯を選択可能）
  DELV_STATUS: string
  DESIRED_DATE_LIST: {
    DESIRED_DATE: string
    DESIRED_DATE_FORMATTED: string
  } [] // 希望日リスト
  DESIRED_DATE: string // 希望日（YYYYMMDD）
  PKG_DROP: {
    PKG_DROP_CD: string // 置配コード
    PKG_DROP_NAME: string // 置配名称
  } [] // 置配
  DELV_TIME: {
    DIST_TIMEZONE_CD: string // 配達時間帯コード
    DIST_TIMEZONE_NAME: string // 配達時間帯名称
  } [] // 配達時間帯
}

interface IResponse {
  _obj0?: DistDateChangedAcceptValue[]
  isError: boolean
}

/**
 * [GET] SearchDistDateChangedAccept.json
 * 配達日変更受付を検索する：配達日変更受付画面を表示した際の初期表示情報を検索する
 * */
export const useSearchDistDateChangedAccept = (params: IRequest | undefined) => {
  const url = '/sinfoniacloud/api/SearchDistDateChangedAccept.json'
  const query = useMcdApiQuery<IResponse>(url, params, {enabled: !!params})

  const rows = query.data?.data.body?._obj0
  const row = rows && rows.length > 0 ? rows[0] : undefined

  row?.DESIRED_DATE_LIST.forEach((row) => {
    try {
      const date = new Date(`${row.DESIRED_DATE.substring(0,4)}-${row.DESIRED_DATE.substring(4, 6)}-${row.DESIRED_DATE.substring(6, 8)}`)
      const week = ['日', '月', '火', '水', '木', '金', '土']
      row.DESIRED_DATE_FORMATTED = date.getFullYear() + '/'
      row.DESIRED_DATE_FORMATTED += (date.getMonth() + 1) + '/'
      row.DESIRED_DATE_FORMATTED += date.getDate() + ' '
      row.DESIRED_DATE_FORMATTED += '(' + week[date.getDay()] + ')'
    } catch (e) {
      console.warn(e)
      row.DESIRED_DATE_FORMATTED = row.DESIRED_DATE
    }
  })

  return query
}

export default useSearchDistDateChangedAccept

/*

{
  "uuid": "70cb814a-88b1-41b1-8a25-544ff2719bb7",
  "documentation": "[PCS] 配達日変更受付を検索する：配達日変更受付画面を表示した際の初期表示情報を検索する",
  "method": "get",
  "endpoint": "SearchDistDateChangedAccept.json",
  "responses": [
      {
          "uuid": "6191303a-7ea8-4ce0-bc30-f6f24d6d76a5",
          "body": "{\r\n  \"isError\": false,\r\n  \"body\": {\r\n    \"_obj0\": [{\r\n      \"DELV_TIME\": [{\r\n        \"DIST_TIMEZONE_CD\": \"01\",\r\n        \"DIST_TIMEZONE_NAME\": \"9:00-12:00\"\r\n      }, {\r\n        \"DIST_TIMEZONE_CD\": \"02\",\r\n        \"DIST_TIMEZONE_NAME\": \"12:00-14:00\"\r\n      }, {\r\n        \"DIST_TIMEZONE_CD\": \"03\",\r\n        \"DIST_TIMEZONE_NAME\": \"14:00-17:00\"\r\n      }, {\r\n        \"DIST_TIMEZONE_CD\": \"04\",\r\n        \"DIST_TIMEZONE_NAME\": \"17:00-21:00\"\r\n      }],\r\n      \"DESIRED_DATE_LIST\": [{\r\n        \"DESIRED_DATE\": \"20230215\"\r\n      }, {\r\n        \"DESIRED_DATE\": \"20230216\"\r\n      }, {\r\n        \"DESIRED_DATE\": \"20230217\"\r\n      }],\r\n      \"INVOICE_NO\": \"2022100100005\",\r\n      \"INVOICE_NO_EXISTS_FLG\": true,\r\n      \"PKG_DROP\": [{\r\n        \"PKG_DROP_CD\": \"01\",\r\n        \"PKG_DROP_NAME\": \"宅配ボックス\"\r\n      }, {\r\n        \"PKG_DROP_CD\": \"02\",\r\n        \"PKG_DROP_NAME\": \"玄関前\"\r\n      }, {\r\n        \"PKG_DROP_CD\": \"03\",\r\n        \"PKG_DROP_NAME\": \"自転車かご\"\r\n      }],\r\n      \"DELV_STATUS\": \"90\",\r\n      \"PKG_DROPPABLE_FLG\": 0,\r\n      \"TIMEZONE_PROV_FLG\": 0\r\n    }]\r\n  }\r\n}",
          "latency": 0,
          "statusCode": 200,
          "label": "",
          "headers": [],
          "bodyType": "INLINE",
          "filePath": "",
          "databucketID": "",
          "sendFileAsBody": false,
          "rules": [],
          "rulesOperator": "OR",
          "disableTemplating": false,
          "fallbackTo404": false,
          "default": true
      },
      {
          "uuid": "3f3ae33d-e2de-4ae2-b108-7482ab7df02e",
          "body": "{\r\n  \"isError\": false,\r\n  \"body\": {\r\n    \"_obj0\": [{\r\n      \"DELV_TIME\": [{\r\n        \"DIST_TIMEZONE_CD\": \"01\",\r\n        \"DIST_TIMEZONE_NAME\": \"9:00-12:00\"\r\n      }, {\r\n        \"DIST_TIMEZONE_CD\": \"02\",\r\n        \"DIST_TIMEZONE_NAME\": \"12:00-14:00\"\r\n      }, {\r\n        \"DIST_TIMEZONE_CD\": \"03\",\r\n        \"DIST_TIMEZONE_NAME\": \"14:00-17:00\"\r\n      }, {\r\n        \"DIST_TIMEZONE_CD\": \"04\",\r\n        \"DIST_TIMEZONE_NAME\": \"17:00-21:00\"\r\n      }],\r\n      \"DESIRED_DATE_LIST\": [{\r\n        \"DESIRED_DATE\": \"20230215\"\r\n      }, {\r\n        \"DESIRED_DATE\": \"20230216\"\r\n      }, {\r\n        \"DESIRED_DATE\": \"20230217\"\r\n      }],\r\n      \"INVOICE_NO\": \"2022100100004\",\r\n      \"INVOICE_NO_EXISTS_FLG\": true,\r\n      \"PKG_DROP\": [{\r\n        \"PKG_DROP_CD\": \"01\",\r\n        \"PKG_DROP_NAME\": \"宅配ボックス\"\r\n      }, {\r\n        \"PKG_DROP_CD\": \"02\",\r\n        \"PKG_DROP_NAME\": \"玄関前\"\r\n      }, {\r\n        \"PKG_DROP_CD\": \"03\",\r\n        \"PKG_DROP_NAME\": \"自転車かご\"\r\n      }],\r\n      \"DELV_STATUS\": \"30\",\r\n      \"PKG_DROPPABLE_FLG\": 0,\r\n      \"TIMEZONE_PROV_FLG\": 0\r\n    }]\r\n  }\r\n}",
          "latency": 0,
          "statusCode": 200,
          "label": "",
          "headers": [],
          "bodyType": "INLINE",
          "filePath": "",
          "databucketID": "",
          "sendFileAsBody": false,
          "rules": [
              {
                  "target": "query",
                  "modifier": "INVOICE_NO",
                  "value": "2022100100004",
                  "invert": false,
                  "operator": "equals"
              }
          ],
          "rulesOperator": "OR",
          "disableTemplating": false,
          "fallbackTo404": false,
          "default": false
      },
      {
          "uuid": "3398d569-9b64-45ee-9405-0495c828b621",
          "body": "{\r\n  \"isError\": false,\r\n  \"body\": {\r\n    \"_obj0\": [{\r\n      \"DELV_TIME\": [{\r\n        \"DIST_TIMEZONE_CD\": \"01\",\r\n        \"DIST_TIMEZONE_NAME\": \"9:00-12:00\"\r\n      }, {\r\n        \"DIST_TIMEZONE_CD\": \"02\",\r\n        \"DIST_TIMEZONE_NAME\": \"12:00-14:00\"\r\n      }, {\r\n        \"DIST_TIMEZONE_CD\": \"03\",\r\n        \"DIST_TIMEZONE_NAME\": \"14:00-17:00\"\r\n      }, {\r\n        \"DIST_TIMEZONE_CD\": \"04\",\r\n        \"DIST_TIMEZONE_NAME\": \"17:00-21:00\"\r\n      }],\r\n      \"DESIRED_DATE_LIST\": [{\r\n        \"DESIRED_DATE\": \"20230215\"\r\n      }, {\r\n        \"DESIRED_DATE\": \"20230216\"\r\n      }, {\r\n        \"DESIRED_DATE\": \"20230217\"\r\n      }],\r\n      \"INVOICE_NO\": \"2022100100005\",\r\n      \"INVOICE_NO_EXISTS_FLG\": true,\r\n      \"PKG_DROP\": [{\r\n        \"PKG_DROP_CD\": \"01\",\r\n        \"PKG_DROP_NAME\": \"宅配ボックス\"\r\n      }, {\r\n        \"PKG_DROP_CD\": \"02\",\r\n        \"PKG_DROP_NAME\": \"玄関前\"\r\n      }, {\r\n        \"PKG_DROP_CD\": \"03\",\r\n        \"PKG_DROP_NAME\": \"自転車かご\"\r\n      }],\r\n      \"DELV_STATUS\": \"50\",\r\n      \"PKG_DROPPABLE_FLG\": 0,\r\n      \"TIMEZONE_PROV_FLG\": 0\r\n    }]\r\n  }\r\n}",
          "latency": 0,
          "statusCode": 200,
          "label": "",
          "headers": [],
          "bodyType": "INLINE",
          "filePath": "",
          "databucketID": "",
          "sendFileAsBody": false,
          "rules": [
              {
                  "target": "query",
                  "modifier": "INVOICE_NO",
                  "value": "1",
                  "invert": false,
                  "operator": "equals"
              }
          ],
          "rulesOperator": "OR",
          "disableTemplating": false,
          "fallbackTo404": false,
          "default": false
      }
  ],
  "enabled": true,
  "responseMode": null
}

*/
